module.exports = __webpack_public_path__ + "img/bahrain.9c4a3a8.webp";